export const pokemonTypes = [
  "Bug",
  "Dark",
  "Dragon",
  "Electric",
  "Fighting",
  "Fire",
  "Flying",
  "Ghost",
  "Grass",
  "Ground",
  "Ice",
  "Normal",
  "Poison",
  "Psychic",
  "Rock",
  "Steel",
  "Water",
  "Curse",
] as const;

export type PokemonType = (typeof pokemonTypes)[number];

export const battleStyles = [
  "free-spirited",
  "total preparation",
  "slow and steady",
  "endurance",
  "high risk, high return",
  "weakening the foe to start",
  "impossible to predict",
  "depend on the battle's flow",
] as const;

export type BattleStyle = (typeof battleStyles)[number];

export const moveToType: Record<string, PokemonType> = {
  Thunderbolt: "Electric",
  "Thunder Wave": "Electric",
  Attract: "Normal",
  Protect: "Normal",
  Earthquake: "Ground",
  "Tri Attack": "Normal",
  Slash: "Normal",
  "Sand Tomb": "Ground",
  "Leaf Blade": "Grass",
  "Leech Seed": "Grass",
  "Aerial Ace": "Flying",
  Detect: "Fighting",
  "Ancient Power": "Rock",
  "Dragon Breath": "Dragon",
  Roar: "Normal",
  "Dream Eater": "Psychic",
  Hypnosis: "Psychic",
  "Confuse Ray": "Ghost",
  Thrash: "Normal",
  Swagger: "Normal",
  Facade: "Normal",
  Flash: "Normal",
  "Quick Attack": "Normal",
  "Drill Peck": "Flying",
  "Mud-Slap": "Ground",
  "Sleep Talk": "Normal",
  Rest: "Psychic",
  Flamethrower: "Fire",
  "Will-O-Wisp": "Ghost",
  "Steel Wing": "Steel",
  "Faint Attack": "Dark",
  "Fire Blast": "Fire",
  "Sunny Day": "Fire",
  "Scary Face": "Normal",
  SmokeScreen: "Normal",
  "Dragon Claw": "Dragon",
  Headbutt: "Normal",
  "Rock Slide": "Rock",
  Psychic: "Psychic",
  Charm: "Normal",
  "Calm Mind": "Psychic",
  "Baton Pass": "Normal",
  "Sludge Bomb": "Poison",
  Bite: "Dark",
  Astonish: "Ghost",
  Screech: "Normal",
  "Extreme Speed": "Normal",
  Crunch: "Dark",
  "Body Slam": "Normal",
  Swift: "Normal",
  "Light Screen": "Psychic",
  "Double Team": "Normal",
  "Double Kick": "Fighting",
  "Thunder Punch": "Electric",
  "Fire Punch": "Fire",
  "Ice Punch": "Ice",
  "Shadow Ball": "Ghost",
  Counter: "Fighting",
  Recover: "Normal",
  "Sky Uppercut": "Fighting",
  "Mach Punch": "Fighting",
  "Magical Leaf": "Grass",
  Reflect: "Psychic",
  "Hi Jump Kick": "Fighting",
  "Milk Drink": "Normal",
  "Icy Wind": "Ice",
  Barrier: "Ice",
  Yawn: "Normal",
  "Bulk Up": "Fighting",
  "Ice Beam": "Ice",
  "Fake Out": "Normal",
  "Lovely Kiss": "Normal",
  "Night Shade": "Ghost",
  Wish: "Normal",
  "Future Sight": "Psychic",
  "Brick Break": "Fighting",
  "Meteor Mash": "Steel",
  "Dizzy Punch": "Normal",
  "Pain Split": "Normal",
  "Horn Drill": "Normal",
  Megahorn: "Bug",
  "Rock Tomb": "Rock",
  "Hydro Pump": "Water",
  Return: "Normal",
  "Dragon Dance": "Dragon",
  "Mirror Coat": "Psychic",
  Hail: "Ice",
  Refresh: "Normal",
  SolarBeam: "Grass",
  Synthesis: "Grass",
  "Rain Dance": "Water",
  "Seismic Toss": "Fighting",
  "Psych Up": "Normal",
  Dig: "Ground",
  "Air Cutter": "Flying",
  Agility: "Psychic",
  "Giga Drain": "Grass",
  "Sleep Powder": "Grass",
  "Hyper Voice": "Normal",
  Surf: "Water",
  "Metal Claw": "Steel",
  "Sand-Attack": "Ground",
  "Sweet Scent": "Normal",
  Amnesia: "Psychic",
  Sing: "Normal",
  Curse: "Curse",
  Blizzard: "Ice",
  "Mega Kick": "Normal",
  "Cross Chop": "Fighting",
  Toxic: "Poison",
  Softboiled: "Normal",
  Metronome: "Normal",
  "Follow Me": "Normal",
  "Petal Dance": "Grass",
  Moonlight: "Normal",
  Aromatherapy: "Grass",
  Minimize: "Normal",
  "Iron Tail": "Steel",
  Thunder: "Electric",
  SmellingSalt: "Normal",
  Bonemerang: "Ground",
  "Double-Edge": "Normal",
  Spikes: "Ground",
  Rollout: "Rock",
  "Defense Curl": "Normal",
  "Hyper Beam": "Normal",
  Pursuit: "Dark",
  Reversal: "Fighting",
  Endure: "Normal",
  "Heat Wave": "Fire",
  Grudge: "Ghost",
  "Focus Punch": "Fighting",
  Bounce: "Flying",
  Explosion: "Normal",
  Spore: "Grass",
  "Perish Song": "Normal",
  "Mean Look": "Normal",
  Fly: "Flying",
  Flail: "Normal",
  "Crush Claw": "Normal",
  Safeguard: "Normal",
  Substitute: "Normal",
  GrassWhistle: "Grass",
  "Blaze Kick": "Fire",
  "Swords Dance": "Normal",
  "Cosmic Power": "Normal",
  Encore: "Normal",
  Disable: "Normal",
  Nightmare: "Ghost",
  "Silver Wind": "Bug",
  Memento: "Dark",
  "Destiny Bond": "Ghost",
  Spark: "Electric",
  Ingrain: "Grass",
  DynamicPunch: "Fighting",
  "Knock Off": "Dark",
  Overheat: "Fire",
  Sandstorm: "Rock",
  Block: "Normal",
  Fissure: "Ground",
  "Zap Cannon": "Electric",
  Trick: "Psychic",
  "Skill Swap": "Psychic",
  "Sheer Cold": "Ice",
  "Stun Spore": "Grass",
  Extrasensory: "Psychic",
  "Secret Power": "Normal",
  Torment: "Dark",
  "Acid Armor": "Poison",
  "Sky Attack": "Flying",
  "Fake Tears": "Dark",
  Superpower: "Fighting",
  "Signal Beam": "Bug",
  Frustration: "Normal",
  Wrap: "Normal",
  "Water Pulse": "Water",
  "Mist Ball": "Psychic",
  "Luster Purge": "Psychic",
  Dive: "Water",
  Revenge: "Fighting",
  "Belly Drum": "Normal",
  Outrage: "Dragon",
};

export const pokemonSpecies = [
  "Aerodactyl",
  "Aggron",
  "Alakazam",
  "Altaria",
  "Ampharos",
  "Arcanine",
  "Armaldo",
  "Articuno",
  "Blastoise",
  "Blaziken",
  "Blissey",
  "Breloom",
  "Charizard",
  "Claydol",
  "Clefable",
  "Cradily",
  "Crobat",
  "Dewgong",
  "Dodrio",
  "Donphan",
  "Dragonite",
  "Dugtrio",
  "Dusclops",
  "Electabuzz",
  "Electrode",
  "Entei",
  "Espeon",
  "Exeggutor",
  "Exploud",
  "Fearow",
  "Feraligatr",
  "Flareon",
  "Flygon",
  "Forretress",
  "Gardevoir",
  "Gengar",
  "Glalie",
  "Golduck",
  "Golem",
  "Granbull",
  "Gyarados",
  "Hariyama",
  "Heracross",
  "Houndoom",
  "Hypno",
  "Jolteon",
  "Jynx",
  "Kangaskhan",
  "Kingdra",
  "Lanturn",
  "Lapras",
  "Latias",
  "Latios",
  "Ludicolo",
  "Machamp",
  "Magmar",
  "Manectric",
  "Marowak",
  "Medicham",
  "Meganium",
  "Metagross",
  "Milotic",
  "Miltank",
  "Misdreavus",
  "Moltres",
  "Mr. Mime",
  "Muk",
  "Nidoking",
  "Nidoqueen",
  "Ninetales",
  "Porygon2",
  "Quagsire",
  "Raichu",
  "Raikou",
  "Rapidash",
  "Regice",
  "Regirock",
  "Registeel",
  "Rhydon",
  "Salamence",
  "Sceptile",
  "Scizor",
  "Shiftry",
  "Shuckle",
  "Skarmory",
  "Slaking",
  "Slowbro",
  "Slowking",
  "Snorlax",
  "Starmie",
  "Steelix",
  "Suicune",
  "Swampert",
  "Tauros",
  "Tentacruel",
  "Typhlosion",
  "Tyranitar",
  "Umbreon",
  "Ursaring",
  "Vaporeon",
  "Venusaur",
  "Victreebel",
  "Vileplume",
  "Wailord",
  "Walrein",
  "Weezing",
  "Whiscash",
  "Xatu",
  "Zapdos",
] as const;

export type PokemonSpecies = (typeof pokemonSpecies)[number];

export type Pokemon = {
  type: string;
  style: string;
  species: PokemonSpecies;
  set: string;
  nature: string;
  item: string;
  move1: string;
  move2: string;
  move3: string;
  move4: string;
  abilities: string;
  evs: string;
  speed: string;
};
